import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=f1ae2238&lang=pug&"
import script from "./input-date.vue?vue&type=script&lang=js&"
export * from "./input-date.vue?vue&type=script&lang=js&"
import style0 from "./input-date.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports